import { Auth } from "aws-amplify";

export const getUser = async () => {
    try {
        const user = await Auth.currentAuthenticatedUser(); // Await the promise
        return user.username; // Return the username
    } catch (err) {
        console.log("Error in getUser: ", err);
        return null; // Handle the case where user is not authenticated
    }
};

export const createPromptAPI = async (formData) => {
    formData.append("created_by", await getUser());
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/prompts`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Creating Prompt: ${error.message}`);
    }
};

// prompt_id, prompt, commit_message, created_by in formdata
export const editPromptAPI = async (formData) => {
    formData.append("created_by", await getUser());
    const prompt_id = formData.get("prompt_id");
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/prompts/${prompt_id}`,
            {
                method: "PUT",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Editing Prompt: ${error.message}`);
    }
};

// prompt_id in params
export const getPromptAPI = async (prompt_id) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/prompts/${prompt_id}`,
            {
                method: "GET",
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Getting Prompt: ${error.message}`);
    }
};

// prompt_id in params
export const getPromptVersionsAPI = async (prompt_id) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/prompts/${prompt_id}/versions`,
            {
                method: "GET",
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Getting Prompt Versions: ${error.message}`);
    }
};

export const getAllPromptsAPI = async () => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/all_prompts`,
            {
                method: "POST",
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Getting All Prompts: ${error.message}`);
    }
};

// users_prompt in params
export const enhancePromptAPI = async (users_prompt) => {
    const username = await getUser();
    const formData = new FormData();
    formData.append("users_prompt", users_prompt);
    formData.append("username", username);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/enhance`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Enhancing Prompt: ${error.message}`);
    }
};

// prompt_id in params, version in params
export const deployPromptAPI = async (prompt_id, version) => {
    const formData = new FormData();
    formData.append("prompt_id", prompt_id);
    formData.append("version", version);
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/deploy_prompt`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(`Error in Deploying Prompt: ${error.message}`);
    }
};

